<template>
  <div class="modal project-settings-modal" :class="{'is-active': showModal}">
    <div class="modal-background" @click="showModal = false"></div>
    <div class="modal-content project-settings-modal__shell">
      <div class="box modal-container project-settings-modal__panel">
        <div class="modal-content-root project-settings-modal__inner">
          <h2 class="project-settings-modal__title title-font">
            Settings for project - {{ site.name }}
          </h2>

          <div class="project-settings-modal__field">
            <label class="project-settings-modal__label" for="project-settings-name">Project name</label>
            <v-text-field
              id="project-settings-name"
              v-model="siteName"
              dense
              outlined
              hide-details="auto"
              single-line
              class="project-settings-modal__text-field"
            />
          </div>

          <div class="project-settings-modal__field">
            <span class="project-settings-modal__label">Default location</span>
            <div class="control">
              <multiselect
                class="project-settings-modal__multiselect"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                v-model="proxyLocation"
                :options="googleSearchLocations"
                placeholder="Select location"
              >
                <template #caret="{ toggle }">
                  <div
                    class="multiselect__select project-settings-modal__multiselect-caret"
                    @mousedown.prevent.stop="toggle()"
                  >
                    <i class="material-icons" aria-hidden="true">keyboard_arrow_down</i>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>

          <div class="project-settings-modal__field">
            <span class="project-settings-modal__label">Default target language</span>
            <multiselect
              class="project-settings-modal__multiselect"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              v-model="targetLang"
              :options="targetLanguages"
              placeholder="Select language"
              @select="handleLanguageSelected">
              <template #caret="{ toggle }">
                <div
                  class="multiselect__select project-settings-modal__multiselect-caret"
                  @mousedown.prevent.stop="toggle()"
                >
                  <i class="material-icons" aria-hidden="true">keyboard_arrow_down</i>
                </div>
              </template>
              <template v-slot:option="props">
                {{ props.option | capitalize }}
              </template>
              <template v-slot:singleLabel="props">
                {{ props.option | capitalize }}
              </template>
            </multiselect>
          </div>

          <div class="project-settings-modal__checkbox-row">
            <label class="project-settings-modal__checkbox">
              <input v-model="ignoreSpaces" class="project-settings-modal__checkbox-input" type="checkbox" />
              <span class="project-settings-modal__checkbox-text">Special language support</span>
            </label>
          </div>

          <div class="project-settings-modal__actions">
            <v-btn
              rounded
              depressed
              class="project-settings-modal__btn-save text-none font-weight-bold"
              :disabled="siteName.trim() === ''"
              @click="saveProjectSettingsAction"
            >
              Save changes
            </v-btn>
            <v-btn
              rounded
              outlined
              class="project-settings-modal__btn-delete text-none font-weight-bold"
              @click="deleteProjectAction"
            >
              Delete project
            </v-btn>
          </div>
        </div>
      </div>
      <button
        class="custom-modal-close-btn project-settings-modal__close"
        type="button"
        aria-label="close"
        @click="showModal = false"
      >
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: { Multiselect },
  data () {
    return {
      showModal: false,

      proxies: [],

      site: {},
      siteName: '',
      proxyLocation: '',
      targetLang: '',
      ignoreSpaces: false,
      useAdvancedStrategyByDefault: false,

      errorMsg: '',
    }
  },
  computed: {
    targetLanguages () {
      return this.$store.state.targetLanguages
    },
    googleSearchLocations () {
      return this.$store.state.googleSearchLocations
    }
  },
  methods: {
    handleLanguageSelected (option) {
      const val = option.includes('extension') ? 'extension_use' : option
      this.targetLang = val
    },
    show(site) {
      this.loadProxiesAndLanguages()

      if (site) {
        this.site = site
        this.siteName = site.name

        let settings = site.settings
        if (settings) {
          this.targetLang = settings.targetLang
          this.ignoreSpaces = settings.ignoreSpaces==1
          this.proxyLocation = settings.proxyLocation
          this.useAdvancedStrategyByDefault = settings.useAdvancedStrategyByDefault == 1
        }
        this.showModal = true
      }
    },
    saveProjectSettingsAction () {
      if (!this.site) return

      this.$store.commit('showLoading')
      this.$store.dispatch('saveProjectSettings', {
        siteId: this.site.id,
        siteName: this.siteName,
        targetLang: this.targetLang,
        proxyLocation: this.proxyLocation,
        ignoreSpaces: this.ignoreSpaces ? 1 : 0,
        useAdvancedStrategyByDefault: this.useAdvancedStrategyByDefault ? 1 : 0,
      })
      .then((res) => {
        if (res.data && res.data.status=='SUCCESS') {
          this.showModal = false
          this.$store.commit('setSite', res.data.site)
        } else {
          let error = res.data.error ? res.data.error : ''
          window.alert('Can not update project settings.\n' + error)
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading')
      })
    },
    deleteProjectAction () {
      if (window.confirm('Are you sure you want to delete this project?')) {
        let siteId = this.site.id

        this.$store.commit('showLoading')
        this.$store.dispatch('removeSite', { siteId })
          .then(() => this.$store.dispatch('loadSites'))
          .then((response) => {
            if (response.data && response.data.status === 'SUCCESS') {
              this.$store.commit('setSites', response.data.sites)
              this.$store.commit('setCurrentSiteById', { siteId: '' })
              this.$router.push(`/sites`)
              this.showModal = false
            }
            return 1
          })
          .finally(() => {
            this.$store.commit('hideLoading')
          })
      }
    },

    loadProxiesAndLanguages () {
      if (!this.googleSearchLocations || !this.googleSearchLocations.length) {
        this.$store.commit('showLoading')
        this.$store.dispatch('fetchGoogleSearchLocations')
          .finally(() => {
            this.$store.commit('hideLoading')
          })
      }
    },
  },
  beforeMount () {

  }
}
</script>

<style lang="scss" scoped>
$psm-teal: #00404d;
$psm-orange: #ff5500;
$psm-border: #cfd8dc;
$psm-panel-bg: #f5f6f8;

.project-settings-modal {
  color: $psm-teal;

  // Bulma + main.scss use overflow:auto on modal layers; multiselect dropdowns need to extend past the panel without scrollbars.
  &.modal.is-active {
    overflow: visible !important;
  }

  &.modal > .modal-content.project-settings-modal__shell {
    overflow: visible !important;
    max-height: none !important;
  }

  &.modal > .modal-content .modal-container {
    overflow: visible !important;
  }

  &.modal > .modal-content .modal-content-root {
    max-height: none !important;
    overflow: visible !important;
  }

  &__shell {
    max-width: 550px !important;
    width: 100%;
  }

  &__panel.box {
    background-color: $psm-panel-bg;
    border-radius: 14px;
    border: none;
    box-shadow: 0 8px 32px rgba(0, 64, 77, 0.12);
    padding: 40px;
    margin-bottom: 0;
  }

  &__inner {
    padding-top: 0;
    margin-top: 0 !important;
  }

  &__title {
    color: $psm-teal;
    font-weight: 800;
    font-size: 1.25rem;
    line-height: 1.35;
    margin: 0 0 1.5rem;
    padding-right: 2.5rem;
  }

  &__field {
    margin-bottom: 1.25rem;
  }

  &__label {
    display: block;
    color: $psm-teal;
    font-weight: 400;
    font-size: 0.9375rem;
    margin-bottom: 0.5rem;
  }

  &__checkbox-row {
    margin: 1.25rem 0 1.5rem;
  }

  &__checkbox {
    display: inline-flex;
    align-items: center;
    gap: 0.65rem;
    cursor: pointer;
    margin: 0;
  }

  &__checkbox-input {
    width: 1.125rem;
    height: 1.125rem;
    border: 1px solid $psm-border;
    border-radius: 4px;
    accent-color: $psm-teal;
    cursor: pointer;
    flex-shrink: 0;
  }

  &__checkbox-text {
    color: $psm-teal;
    font-weight: 700;
    font-size: 0.9375rem;
  }

  &__actions {
    display: flex;
    align-items: stretch;
    gap: 0.75rem;
    margin-top: 0.25rem;
  }

  &__close {
    color: $psm-teal !important;

    .material-icons {
      font-size: 1.5rem;
    }
  }
}

::v-deep .project-settings-modal__text-field {
  margin-top: 0;
  padding-top: 0;

  .v-input__slot {
    min-height: 44px !important;
    border-radius: 8px !important;
    background: #fff !important;
  }

  fieldset {
    border-color: $psm-border !important;
    border-width: 1px !important;
    border-radius: 8px !important;
    top: -8px;
  }

  .v-text-field__slot input {
    color: $psm-teal !important;
    font-size: 0.9375rem;
  }
}

::v-deep .project-settings-modal__multiselect.multiselect {
  min-height: 44px;
  color: $psm-teal;
}

::v-deep .project-settings-modal__multiselect.multiselect--active {
  z-index: 120;
}

::v-deep .project-settings-modal__multiselect .multiselect__tags {
  min-height: 44px;
  padding: 10px 40px 10px 12px;
  border: 1px solid $psm-border;
  border-radius: 8px;
  background: #fff;
}

::v-deep .project-settings-modal__multiselect .multiselect__input,
::v-deep .project-settings-modal__multiselect .multiselect__single {
  color: $psm-teal;
  font-size: 0.9375rem;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

::v-deep .project-settings-modal__multiselect .multiselect__placeholder {
  color: rgba(0, 64, 77, 0.45);
  font-size: 0.9375rem;
  margin-bottom: 0;
  padding-top: 0;
}

// Caret uses Material Icons via #caret slot; layout matches multiselect hit target.
::v-deep .project-settings-modal__multiselect .project-settings-modal__multiselect-caret {
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 40px;
  height: auto !important;
  min-height: 42px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    display: none !important;
  }

  .material-icons {
    font-size: 22px;
    color: rgba(0, 64, 77, 0.55);
    line-height: 1;
    user-select: none;
    pointer-events: none;
  }
}

::v-deep .project-settings-modal__actions > .v-btn {
  flex: 1 1 0;
  min-width: 0 !important;
  width: 100%;
}

::v-deep .project-settings-modal__btn-save.v-btn {
  background-color: $psm-orange !important;
  border-color: $psm-orange !important;
  color: #fff !important;
  min-height: 64px !important;
  border-radius: 64px;
  padding: 0 1rem !important;
  letter-spacing: normal;
  text-transform: none;
  box-shadow: none !important;
  .v-btn__content {
    font-size: 1.1rem !important;
    font-weight: 400;
  }
}

::v-deep .project-settings-modal__btn-save.v-btn.v-btn--disabled {
  background-color: rgba(255, 85, 0, 0.35) !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

::v-deep .project-settings-modal__btn-delete.v-btn {
  border-width: 2px !important;
  border-color: $psm-orange !important;
  color: $psm-orange !important;
  background-color: transparent !important;
  min-height: 64px !important;
  border-radius: 64px;
  padding: 0 1rem !important;
  letter-spacing: normal;
  text-transform: none;
  .v-btn__content {
    font-size: 1.1rem !important;
    font-weight: 400;
  }
}
</style>
